/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {TimelineLite} from "gsap";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesLogo} from "../../logo/BonusBunniesLogo";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {BonusBunniesReelController} from "../../reel/BonusBunniesReelController";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";

export class BonusBunniesFreeSpinIntroController extends FreespinIntroController {

    private static _fsWon:number = 0;
    private static _isRestoreState:boolean;
    private static _multiplierValue:number;
    private static _bonusSpinsValue:number;
    private _isBigWin:boolean = false;

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:BonusBunniesParsedGameData | BonusBunniesParsedInitData):boolean {
        this._isBigWin = (<BonusBunniesParsedGameData>data).isBigWin;
        BonusBunniesFreeSpinIntroController._isRestoreState = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        this._isRestoreFreespin = BonusBunniesFreeSpinIntroController._isRestoreState && data.freespinsLeft > 0;
        this._isFreespinWon = data.mode == BonusBunniesGameMode.NORMAL && data.nextMode == BonusBunniesGameMode.BONUS_GAME;
        BonusBunniesFreeSpinIntroController._fsWon = data.freespinsLeft;
        this._remainingFreeSpins = data.freespinsLeft;
        if(BonusBunniesFreeSpinIntroController._isRestoreState == true) {
            BonusBunniesFreeSpinIntroController._multiplierValue = data.totalBonusWinMultiplierBefore;
        } else {
            BonusBunniesFreeSpinIntroController._multiplierValue = data.totalBonusWinMultiplierAfter;
        }

        BonusBunniesFreeSpinIntroController._bonusSpinsValue = data.bonusSpinsRemaining;
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    protected close():void {
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.CONTINUE_BUTTON_CLICK);
        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
        super.close();
    }

    protected show():boolean {
        if(this.shouldShow()) {
            this._view.show(this._serverData!, () => this.onShowComplete());
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
            this._isShowing = true;
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }
        if (this._isRestoreFreespin == true && this.shouldShow() == false){
            SlotGame.keypad.setZeroBetSpinCounter(this._remainingFreeSpins);
        }
        return this._isFreespinWon;
    }

    protected hideKeypad() {

    }

    protected onCloseComplete():void {
        BonusBunniesFreeSpinIntroController.clearAllReelsStopDelay();
        SlotGame.sound.playAmbience(BonusBunniesSoundConfig.instance.BONUS_GAME_AMBIANCE, 0, 0);
        BonusBunniesFreeSpinIntroController.setBonusGameReelStopSounds();
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterController.initBonusSpinsCounter();
        if(BonusBunniesFreeSpinIntroController._isRestoreState == true) {
            BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.abortZeppelinanimation();
            BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.restartZeppelinAnimation();
        }
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.enableChest();

        SlotGame.keypad.show();

        EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        let delay:number = 2;
        if(this._isFreespinWon == true) {
            delay = 0;
        }
        const delayTL:TimelineLite = new TimelineLite({
            delay : delay,
            onComplete : () => EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED))
        });
        if(this._isFreespinWon == true) {
            delayTL.add(BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.getAttentionOnAllVSymbolsTL());
            delayTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPController.initMultiplierText(), "+=0.3");
            delayTL.add(new TimelineLite({delay : 0.2}));
        } else {
            BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPController.initMultiplierText();
        }
    }

    private static setReelsToBonusReels():void {
        for(let i:number = 0; i < 25; i++) {
            let reel:(StateReelSymbol | null)[] = Reels.allSymbols(i);
            for(let j:number = 0; j < reel.length; j++) {
                reel[j]!.replaceWith("X", j);
            }
        }
    }

    private static setBonusGameReelStopSounds():void {
        BonusBunniesSoundConfig.instance.REELS_DEFAULT_BOUNCE = [];
        for(let i:number = 0; i < BonusBunniesSoundConfig.instance.REELS_BONUS_GAME_BOUNCE.length; i++) {
            BonusBunniesSoundConfig.instance.REELS_DEFAULT_BOUNCE.push(BonusBunniesSoundConfig.instance.REELS_BONUS_GAME_BOUNCE[i]);
        }
    }

    private static clearAllReelsStopDelay():void {
        for(let i:number = 0; i < BonusBunniesGameConfig.instance.REELS_NUM; i++) {
            (<BonusBunniesReelController>Reels.getReel(i)).resetStopDelay();
        }
    }

    public static actuallyDoTransition() {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : BonusBunniesGameMode.FREESPIN}));
        this.setReelsToBonusReels();
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.disable30LinesPicture();
        if(BonusBunniesFreeSpinIntroController._isRestoreState == true) {
            BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.setRestoreStickyBonusSyms();
        } else {
            BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController.setStickyBonusSyms();
            BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.abortZeppelinanimation();
            BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.restartZeppelinAnimation();
        }
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.initiBonusGame();
        BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.set4RowPosition();
        BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.enableInfo();
        BonusBunniesLogo.bonusBunniesLogo.disableLogo();
        BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPController.isB5Win = false;
        SlotGame.keypad.setZeroBetSpinCounter(BonusBunniesFreeSpinIntroController._fsWon);
        BonusBunniesGameModuleConfig.bonusBunniesInitialWPView.cleanupSpineWinSymbols();
    }
}